import { useTheme } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';
import React from 'react';

import { FilterPill } from '../../../components';
import { Floorplan, ImageIcon, ThreeSixty, Video } from '../../../icons';
import { getStyles } from './GalleryButton.styles';

export enum GalleryFilterType {
  IMAGE = 'image',
  VIDEO = 'video',
  THREE_SIXTY = '360tour',
  FLOORPLAN = 'floorplan',
}

export interface GalleryButtonProps {
  label: string | null;
  type: GalleryFilterType;
  onClick: ButtonProps['onClick'];
}

const iconMap = {
  [GalleryFilterType.IMAGE]: ImageIcon,
  [GalleryFilterType.VIDEO]: Video,
  [GalleryFilterType.THREE_SIXTY]: ThreeSixty,
  [GalleryFilterType.FLOORPLAN]: Floorplan,
};

export const GalleryButton = ({ label, type, onClick }: GalleryButtonProps): React.ReactElement => {
  const Icon = iconMap[type];
  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <FilterPill
      id={`gallery-button-${type}`}
      className="estate-filter-pill"
      avatar={Icon && <Icon sx={styles.filterPillIcon} />}
      label={label}
      onClick={onClick}
      sx={styles.filterPill}
    />
  );
};

GalleryButton.displayName = 'GalleryButton';
